import { isMobile } from "is-mobile";
import Translate, { getLanguageCode } from "../../utils/Translate";
import Api from "../../utils/Api";

export async function addLicenseToGoogleWallet(api, digitalLicenseId, dataId) {
  const response = await api.fetch(
    `${import.meta.env.VITE_MAIN_URL}wallet/google/digital-license?digitalLicenseId=${digitalLicenseId}&dataId=${dataId}`,
    false,
    "GET",
  );
  if (response.isSuccessful) {
    window.open(response.addToWalletUrl, "_blank", "rel=noopener noreferrer");
  }
}

export async function addLicenseToAppleWallet(digitalLicenseId, dataId, enqueueSnackbar, closeSnackbar) {
  if (!isMobile({ tablet: true, featureDetect: true })) {
    const errorMessage = enqueueSnackbar(Translate.get("OnlyMobileSupportBody"), {
      variant: "error",
      autoHideDuration: 6000,
      onClick: () => closeSnackbar(errorMessage),
    });
    return;
  }

  const blob = await Api.fetchBlob(
    `${import.meta.env.VITE_MAIN_URL}wallet/apple/digital-license?digitalLicenseId=${digitalLicenseId}&dataId=${dataId}`,
    false,
    "GET",
  );
  var a = document.createElement("a");
  a.href = window.URL.createObjectURL(blob);
  a.download = `digitallicense${digitalLicenseId}.pkpass`;
  a.click();
}

export function canShareDigitalLicense() {
  return isMobile({ tablet: true, featureDetect: true }) && navigator.canShare();
}

export async function shareDigitalLicenseOrCopyLink(publicShareUrl, enqueueSnackbar, closeSnackbar) {
  if (isMobile({ tablet: true, featureDetect: true }) && navigator.canShare()) {
    await navigator.share({
      title: Translate.get("DigitalLicenseLabel"),
      url: publicShareUrl,
    });
  } else {
    navigator.clipboard.writeText(publicShareUrl);
    const infoMessage = enqueueSnackbar(Translate.get("CopiedToClipboard"), {
      variant: "info",
      autoHideDuration: 6000,
      onClick: () => closeSnackbar(infoMessage),
    });
  }
}

const walletUrlLang = {
  9: "EN",
  12: "FR",
  29: "SE",
};

export function getGoogleWalletImgSrc() {
  const langCode = getLanguageCode();
  const lang = walletUrlLang[langCode] ?? "SE";
  return `https://eportpublic.blob.core.windows.net/others/google/add_to_google_wallet_badge_${lang}.svg?sp=r&st=2024-04-12T07:06:58Z&se=2064-04-12T15:06:58Z&spr=https&sv=2022-11-02&sr=c&sig=STfImuoPxA9srWpHhIHlMAaW7w9ST8G1CYcpsinC6PQ%3D`;
}

export function getAppleWalletImgSrc() {
  const langCode = getLanguageCode();
  const lang = walletUrlLang[langCode] ?? "SE";
  return `https://eportpublic.blob.core.windows.net/others/apple/add_to_apple_wallet_${lang}.svg?sp=r&st=2024-04-12T07:06:58Z&se=2064-04-12T15:06:58Z&spr=https&sv=2022-11-02&sr=c&sig=STfImuoPxA9srWpHhIHlMAaW7w9ST8G1CYcpsinC6PQ%3D`;
}
